export default function isEmpty(value: string | number): boolean {
  if (value === undefined || value === "" || value === 0 || value === null) {
    return true;
  }
  return false;
}
